var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.875 7.429c.31 0 .576.111.795.334.22.224.33.493.33.808v10.286c0 .316-.11.585-.33.808-.22.223-.484.335-.795.335H4.125c-.31 0-.576-.112-.795-.335a1.11 1.11 0 0 1-.33-.808V8.571c0-.315.11-.584.33-.808.22-.223.484-.334.795-.334h4.5V5.527c0-.578.299-.98.896-1.206C10.043 4.107 10.87 4 12 4c1.137 0 1.963.107 2.479.321.597.227.896.628.896 1.206v1.902h4.5zm-9.378-1.527v1.527h3.006V5.902h-3.006z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.33132dd3e3728fb8d2ff24ba0df22037.svg";
export { ForwardRef as ReactComponent };